import { AxiosResponse } from "axios";
import advService from "../../../../../util/advService";
import {
    Excel_FILE_MAPPING_LIST_DECLARATIONS,
    GET_EXCEL_FILE_MAPPING,
} from "../../../../../util/newconfig";
import { JavaResponse } from "../../../../../types";
import Dropdown from "../../../../../components/Input/Dropdown";
import { useState } from "react";
import { ManageMultipleDeclarationsStore } from "../ManageMultipleDeclarations";
import {
    Box,
    FormControl,
    FormControlLabel,
    FormLabel,
    Radio,
    RadioGroup,
    Stack,
    TextField,
    Typography,
} from "@mui/material";
import { getFormattedXLSXData } from "../../../../../services/lib/xlsxService";
// import  ExcelTemplate from "./BulkDeclarationTemplate.xlsx"

type Props = {
    close: () => void;
    uuid: string;
    pid: string;
    refresh: () => void;
    store: ManageMultipleDeclarationsStore;
    setStore: React.Dispatch<
        React.SetStateAction<ManageMultipleDeclarationsStore>
    >;
};

const handleStep1 = (
    mapping: string,
    setStore: React.Dispatch<
        React.SetStateAction<ManageMultipleDeclarationsStore>
    >,
    newMappingName: string = "",
    mappings: Record<string, string> | null = {}
) => {
    debugger;
    if (mapping === "new") {
        // Handle new mapping logic
        setStore((prev) => ({
            ...prev,
            selectedMapping: mapping,
            selectedMappingMapping: {},
            selectedMappingDateMapping: {},
            step: 2,
            newMappingName: newMappingName,
        }));
    } else {

        if (mapping === "Default Mapping") {
            let mappingMap = {
                consignmentDetails: "Consignment Details",
                declarationDate: "Declaration Date",
                goodsValue: "Goods Value",
                invoiceDate: "Invoice Date",
                invoiceNumber: "Invoice Number",
                receiverAddress: "Receiver Address",
                receiverName: "Receiver Name",
                remark: "Remark",
                senderName: "Sender Name",
                transportationMode: "Transportation Mode",
                transportationNumber: "Transportation Number",
            };
            let dateMapping = {
                declarationDate: "dd-mm-yyyy",
                invoiceDate: "dd-mm-yyyy",
            };


            setStore((prev) => ({
                ...prev,
                selectedMapping: mapping,
                selectedMappingMapping: mappingMap,
                selectedMappingDateMapping: dateMapping,
                step: 2,
            }));
        } else if (mappings && mappings[mapping]) {
            let config = { ...GET_EXCEL_FILE_MAPPING };
            config.url = config.url.replace("{mapping_uuid}", mappings[mapping]);
            advService(
                config,
                {},
                (
                    response: AxiosResponse<
                        JavaResponse<{
                            text: string;
                        }>
                    >
                ) => {
                    if (response.data.success) {
                        setStore((prev) => ({
                            ...prev,
                            selectedMapping: mapping,
                            selectedMappingMapping: JSON.parse(
                                response.data.response.text || "{}"
                            )?.schemaToDisplayText,
                            selectedMappingDateMapping: JSON.parse(
                                response.data.response.text || "{}"
                            )?.dateFormatText,
                            step: 2,
                        }));
                    } else {
                        console.error("Failed to fetch mapping");
                    }
                }
            );
        }
    }
};

const ManageMultipleDeclarationsStep1 = (props: Props) => {
    const [newMappingError, setNewMappingError] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [selectedMapping, setSelectedMapping] = useState<string>("");
    let config = { ...Excel_FILE_MAPPING_LIST_DECLARATIONS };
    config.url = config.url.replace("{entityId}", props.uuid);
    if (!props.store.mappings) {
        advService(
            config,
            {},
            (response: AxiosResponse<JavaResponse<Record<string, string>>>) => {
                if (response.status === 200) {
                    debugger;
                    props.setStore((prev) => ({
                        ...prev,
                        mappings: response.data.response,
                    }));
                } else {
                    console.error("Failed to fetch declaration");
                }
            }
        );
    }

    return (
        <div>
            <FormControl>
                <RadioGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={props.store.selectedMapping}
                    onChange={(e) => {
                        props.setStore((prev) => ({
                            ...prev,
                            selectedMapping: e.target.value,
                        }));
                    }}
                >
                    {Object.keys(props.store.mappings || {}).map((mapping) => (
                        <FormControlLabel
                            key={mapping}
                            value={mapping}
                            control={<Radio />}
                            label={
                                <Typography
                                    variant="navbutton"
                                    sx={{
                                        color: "#3E3C47",

                                        fontSize: "14px",
                                        fontStyle: "normal",
                                        fontWeight: "500",
                                    }}
                                >
                                    {mapping}
                                </Typography>
                            }
                        />
                    ))}
                    <Stack direction="column">
                        <FormControlLabel
                            value="Default Mapping"
                            control={<Radio />}
                            label={
                                <Box>
                                    <Typography
                                        variant="navbutton"
                                        sx={{
                                            color: "#3E3C47",

                                            fontSize: "14px",
                                            fontStyle: "normal",
                                            fontWeight: "500",
                                        }}
                                    >
                                        Default Schema
                                    </Typography>
                                    <Stack direction="row" spacing={1}>
                                        <Typography
                                            variant="body3"
                                            sx={{
                                                color: "#6F6B7A",
                                                fontSize: "12px",
                                                fontStyle: "normal",
                                                fontWeight: "400",
                                            }}
                                        >
                                            Use our template for seamless
                                            mapping.
                                        </Typography>
                                        <Typography
                                            variant="body3"
                                            sx={{
                                                color: "var(--primary)",
                                                fontSize: "12px",
                                                fontStyle: "normal",
                                                fontWeight: "600",
                                            }}
                                            onClick={() => {
                                                const fileUrl = "/BulkDeclarationTemplate.xlsx";
                                                
                                                // Create a link element
                                                const link = document.createElement("a");
                                                link.href = fileUrl;
                                                link.download = "declaration_template.xlsx";
                                                document.body.appendChild(link);
                                                
                                                // Trigger the download
                                                link.click();
                                                
                                                // Clean up
                                                document.body.removeChild(link);
                                            }}
                                        >
                                            Download Template
                                        </Typography>
                                    </Stack>
                                </Box>
                            }
                        />
                    </Stack>
                    <FormControlLabel
                        value="new"
                        control={<Radio />}
                        label={
                            <Stack
                                spacing={4}
                                direction="row"
                                alignItems="center"
                            >
                                <Typography
                                    variant="navbutton"
                                    sx={{
                                        color: "#3E3C47",

                                        fontSize: "14px",
                                        fontStyle: "normal",
                                        fontWeight: "500",
                                    }}
                                >
                                    New Mapping
                                </Typography>
                                {props.store.selectedMapping === "new" && (
                                    <TextField
                                        label=""
                                        variant="outlined"
                                        value={props.store.newMappingName}
                                        onChange={(e) => {
                                            props.setStore((prev) => ({
                                                ...prev,
                                                newMappingName: e.target.value,
                                            }));
                                        }}
                                        error={!!newMappingError}
                                        helperText={newMappingError}
                                    />
                                )}
                            </Stack>
                        }
                    />
                </RadioGroup>
            </FormControl>
            <div className="buttons">
                <button
                    className="btn simple"
                    type="button"
                    onClick={() =>
                        props.setStore((prev) => ({
                            ...prev,
                            step: -1,
                        }))
                    }
                >
                    Cancel
                </button>
                <button
                    className="btn simple primary"
                    type="submit"
                    disabled={isLoading}
                    onClick={() => {
                        if (props.store.selectedMapping === "new") {
                            if (props.store.newMappingName.trim() === "") {
                                setNewMappingError("Please enter a name");
                                return;
                            } else if (
                                props.store.newMappingName === "new"
                            ) {
                                setNewMappingError(
                                    "Mapping name cannot be 'new'"
                                );
                                return;
                            } else {
                                setNewMappingError("");
                            }
                        }

                        // get file from user and save it in the store
                        const fileInput = document.createElement("input");
                        fileInput.type = "file";
                        fileInput.accept = ".xls,.xlsx,.csv,.xlsm,.xlsb";

                        fileInput.onchange = (e) => {
                            const target = e.target as HTMLInputElement;
                            if (target.files && target.files[0]) {
                                const file = target.files[0];
                                const reader = new FileReader();
                                reader.onload = (event) => {
                                    const data = new Uint8Array(
                                        event.target?.result as ArrayBuffer
                                    );
                                    let binary = "";
                                    let bytes = new Uint8Array(data);
                                    let len = bytes.byteLength;
                                    for (let i = 0; i < len; i++) {
                                        binary += String.fromCharCode(bytes[i]);
                                    }
                                    let formattedData =
                                        getFormattedXLSXData(binary);
                                    debugger;
                                    props.setStore((prev) => ({
                                        ...prev,
                                        data: formattedData,
                                    }));

                                    handleStep1(
                                        props.store.selectedMapping,
                                        props.setStore,
                                        props.store.newMappingName,
                                        props.store.mappings
                                    );
                                };

                                reader.readAsArrayBuffer(file);
                            }
                        };
                        fileInput.click();
                    }}
                >
                    Next
                </button>
            </div>
        </div>
    );
};

export default ManageMultipleDeclarationsStep1;
